
 export const Regex = {
    Pan : /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
    Gst: /^\d{2}[A-Za-z0-9]{13}$/,
    Acc: /^\d{9,18}$/,
    Ifsc: /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/
  }
  